import React from "react";
import ReactGA from "react-ga";
import { withRouter } from "react-router-dom";
import classnames from "classnames";
import { connect } from "react-redux";
import { Carousel } from "react-bootstrap";
import {
  faEdit,
  faUndo,
  faClock,
  faCircle,
  faCamera,
} from "@fortawesome/free-solid-svg-icons";
import {
  approveArticle,
  reportArticleUndo,
  approveArticleUndo,
  batchApprovedUpdate,
  batchReportedUpdate,
} from "redux/actions/detail";
import { closeModal, setArticlesPinned } from "redux/actions/global";
import Icon from "components/Icon";
import ArticlePrice from "components/ArticlePrice";
import { t, uniq, get, isAvailableToDenounce } from "utils";

import { MANUAL_EVENT } from "../../../../helpers/userTrack";
import Tooltip from "components/Tooltip";
import TooltipNew from "components/Tooltip/ToolTipNew";

const ArticleCard = (props) => {
  const {
    profile,
    article,
    history,
    batchApproved,
    batchReported,
    isBatchActive,
    approveArticle,
    setArticlesPinned,
    isUpdatingArticle,
    reportArticleUndo,
    approveArticleUndo,
    batchApprovedUpdate,
    batchReportedUpdate,
    onOpenArticleDetail,
    prefixGA,
    closeModal,

    // ✅ NUEVO (vienen desde Articles)
    isSelected = false,
    onToggleSelect,
    canSelectMore = true,
    index,
  } = props;
  let batchCatalogTooltip = null;
  const hasPicture = article.thumbnail;
  const indexApproved = batchApproved.indexOf(article.id);
  const indexReported = batchReported.indexOf(article.id);
  const isBatchApproved = indexApproved > -1;
  const isBatchReported = indexReported > -1;

  const titleTranslate = get(article, "translate.title", article.title);
  const originModel = get(article, "originModel", null);
  const qs = originModel ? `?origin_model=${originModel}` : "";

  const previewImages =
    hasPicture && article.images && article.images.length === 0
      ? [{ secure_url: hasPicture }]
      : [];

  const [images, setImages] = React.useState(
    previewImages.length === 0 ? article.images : previewImages
  );
  const [checked, setChecked] = React.useState(false);

  const checkVisibleImage = React.useCallback(() => {
    if (props.visibleArticles) {
      let check =
        props.visibleArticles.filter((item) => item.id === article.id).length >
        0;
      setChecked(true);
      return check;
    }
  }, [props.visibleArticles, article.id]);

  const getGAEventName = (eventName) => {
    return prefixGA !== undefined ? `${prefixGA}_${eventName}` : eventName;
  };

  const openArticleModal = () => {
    ReactGA.ga("send", "event", "PPPI", getGAEventName("VIEW_ITEM_DETAIL"));
    onOpenArticleDetail(`${article.id}${qs}`);
    closeModal();
  };

  const openArticleModalCatalogo = () => {
    ReactGA.ga("send", "event", "PPPI", getGAEventName("THUMBS_DOWN"));
    history.push(`/article_catalogo_detail/${article.catalogProductId}${qs}`);
  };

  const openArticleReportModal = (e) => {
    e.stopPropagation();
    ReactGA.ga("send", "event", "PPPI", getGAEventName("THUMBS_DOWN"));
    history.push(`/article_detail/${article.id}${qs}#report`);
  };

  const openReportedArticleEditModal = () => {
    history.push(`/article_detail/${article.id}${qs}#report`);
  };

  const removeFromBatchApproved = () => {
    const newBatchApproved = batchApproved.slice(0);
    newBatchApproved.splice(indexApproved, 1);
    batchApprovedUpdate(newBatchApproved);
  };

  const removeFromBatchReported = () => {
    const newBatchReported = batchReported.slice(0);
    newBatchReported.splice(indexReported, 1);
    batchReportedUpdate(newBatchReported);
  };

  const handleApproveArticle = (e) => {
    e.stopPropagation();
    const payload = {
      originModel,
      articlesIds: [article.id],
      author: {
        id: profile.id,
        givenName: profile.givenName,
        familyName: profile.familyName,
      },
    };
    approveArticle(payload);
    props.trackEvent({ type: MANUAL_EVENT.APPROVED_ARTICLE, ...payload });
    props.updateVisibleArticles && setTimeout(props.updateVisibleArticles, 1500);
  };

  const handleApproveArticleUndo = () =>
    approveArticleUndo({
      articleId: article.id,
      livesearchId: article.livesearchId,
    });

  const handleReportArticleUndo = () =>
    reportArticleUndo({
      articleId: article.id,
      livesearchId: article.livesearchId,
    });

  const handleBatchApprovedUpdate = () => {
    const newBatchApproved = batchApproved.slice(0);
    newBatchApproved.push(article.id);
    isBatchReported && removeFromBatchReported();
    batchApprovedUpdate(uniq(newBatchApproved));
  };

  const handleBatchReportedUpdate = () => {
    const newBatchReported = batchReported.slice(0);
    newBatchReported.push(article.id);
    isBatchApproved && removeFromBatchApproved();
    batchReportedUpdate(uniq(newBatchReported));
  };

  const pinnedActive =
    profile &&
      profile.helps &&
      profile.helps.articlesPinned &&
      profile.helps.articlesPinned
      ? profile.helps.articlesPinned.filter((item) => item.id === article.id)
        .length > 0
      : false;

  const pinnedImage = pinnedActive ? "pinned-active.svg" : "pinned-normal.svg";

  const updateArticlePinned = (e) => {
    e.stopPropagation();
    let currentArticles =
      profile &&
      profile.helps &&
      profile.helps.articlesPinned &&
      profile.helps.articlesPinned.map((item) => ({
        articleId: item.id,
        originModel: item.originModel,
      }));
    if (pinnedActive) {
      currentArticles = currentArticles.filter(
        (item) => item.articleId !== article.id
      );
    } else {
      if (!currentArticles) currentArticles = [];
      currentArticles.push({
        articleId: article.id,
        originModel,
      });
    }
    setArticlesPinned(currentArticles);
  };

  const imagesThumb =
    images &&
    images.length >= 1 &&
    images.map((image, index) => {
      return (
        <Carousel.Item key={index}>
          <img
            alt={titleTranslate}
            className="article-image"
            src={image.secure_url
              .replace("http://", "https://")
              .replace("-I.", "-C.")
              .replace("-O.", "-C.")}
          />
        </Carousel.Item>
      );
    });

  const canDenounce = isAvailableToDenounce(article);

  const showAsNoticed = !canDenounce;
  const showAsReported =
    article.reported &&
    (!article.noticed ||
      article.noticed.noticedAt < article.reported.createdAt ||
      (article.reported && !article.reported.createdAt));

  const isInternationalPurchase = article?.tags?.includes("cbt_item");
  const CBTCountry = isInternationalPurchase
    ? article?.seller_address?.search_location?.state?.id === "USA"
      ? "USA"
      : article?.seller_address?.search_location?.state?.name.toUpperCase()
    : undefined;


  const handleCardClick = (e) => {
    if (isBatchActive && !article.catalogListing) {
      e.preventDefault();
      e.stopPropagation();
      if (!isSelected && !canSelectMore) return;
      onToggleSelect && onToggleSelect();
      return;
    }

    if (
      (canDenounce && article.tags?.includes("content_editable")) ||
      !article.catalogListing
    ) {
      openArticleModal();
    } else {
      openArticleModalCatalogo();
    }
  };

  return (
    <div
      id={index === 5 ? 'onboarding-article-6' : (index === 0 ? 'onboarding-article-1' : undefined)}
      onClick={handleCardClick}
      className={classnames(
        "item",
        "images",
        { approved: article.approved },
        { reported: showAsReported },
        { noticed: showAsNoticed },
        { "batch-approved": isBatchApproved },
        { "batch-reported": isBatchReported },
        { "batch-selected": !!isSelected }, // ⭐ resaltar si lo querés con CSS
        { disabled: showAsNoticed },
        { "batch-catalog": isBatchActive && article.catalogListing }
      )}
    >


      {isBatchActive && article.catalogListing && (
        <>
          <div className="batch-catalog-disabled-wrapper" />

          <TooltipNew
            content={
              <div className="tooltipBatchCatalog-ctn">
                <div className="tooltipBatchCatalog-content">
                   {t("no_can_report_massively_catalog_product")}
                </div>
              </div>}
            position="liveSearch-top"
          >
            <img
              src="/images/alerts/iconAlert.png"
              alt="alert"
              className="batch-catalog-disabled-icon"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation(); // no click del card
              }}
            />
          </TooltipNew >
        </>
      )
      }


      {
        !article.catalogListing && !showAsReported && (
          <div
            className={classnames("hover-checkbox", { "hover-checkbox--disabled": !isSelected && !canSelectMore })}
            onClick={(e) => {
              e.stopPropagation();
              if (!isSelected && !canSelectMore) return;
              onToggleSelect && onToggleSelect();
            }}
          >
            <input
              type="checkbox"
              className="batch-checkbox"
              checked={!!isSelected}
              readOnly
              disabled={!isSelected && !canSelectMore}
            />
          </div>
        )
      }

      <div className="article-container">
        <div className="disabled-label">
          <Icon icon={faClock} size="3x" />
          <div className="in-moderation-title">{t("in_moderation_card_title")}</div>
          <div className="in-moderation-text">
            {t("in_moderation_card_text_1")}
            <b>{t("in_moderation_card_text_2")}</b>
            {t("in_moderation_card_text_3")}
          </div>
        </div>

        {article?.seller && (
          <>
            <div className={classnames("blackseller", { hidden: !article.seller.blackSeller })}>
              <div className="flag"></div>
              <Icon icon={faCircle} />
            </div>

            <div className={classnames("whiteseller", { hidden: !article.seller.whiteSeller })}>
              <div className="flag"></div>
              <Icon icon={faCircle} />
            </div>
          </>
        )}

        <div className="article-thumbnail" align="center">
          {originModel && (
            <img
              alt="pinned-icon"
              className={classnames("pinned-icon", { active: pinnedActive })}
              src={`/images/${pinnedImage}`}
              onClick={updateArticlePinned}
            />
          )}

          <div className="overlay">
            {(article.status === "active" && article.catalogListing === false) ||
              (article.status === "pause" && article.catalogListing === false) ? (
              <div className="actions audit-actions">
                <button className="btn suspicious" onClick={openArticleReportModal}>
                  {t("mark_as_suspicious_label")}
                </button>
                <button className="btn" onClick={handleApproveArticle}>
                  {t("mark_as_trusted_label")}
                </button>
              </div>
            ) : null}

            {(article.status === "active" && article.catalogListing === true) ||
              (article.status === "pause" && article.catalogListing === true) ? (
              <div className="actions audit-actions">
                <button
                  className="btn catalogo"
                  onClick={() => {
                    if (!article.tags?.includes("content_editable")) {
                      openArticleModalCatalogo();
                    } else {
                      openArticleModal();
                    }
                  }}
                >
                  {t("mark_as_catalogo_label")}
                </button>
              </div>
            ) : null}

            {(((article.approved && article.approved.author.id === profile.id) ||
              (showAsReported && article.reported.author.id === profile.id))) && (
                <div onClick={(e) => e.stopPropagation()} className="actions audited-actions">
                  {(article.approved || (article.reported && canDenounce)) && (
                    <div>
                      <button
                        className="undo-action action"
                        onClick={article.approved ? handleApproveArticleUndo : handleReportArticleUndo}
                      >
                        <Icon icon={faUndo} />
                        {t("undo")}
                      </button>
                      <button
                        className={classnames("edit-report-action action", { hidden: isUpdatingArticle })}
                        onClick={openReportedArticleEditModal}
                      >
                        <Icon icon={faEdit} />
                        {t("edit")}
                      </button>
                    </div>
                  )}
                </div>
              )}

            <div className="actions batch-actions">
              {((article.status === "active" && !article.catalogListing) ||
                (article.status === "pause" && !article.catalogListing)) && (
                  <>
                    <button
                      className="btn suspicious"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (isBatchReported) removeFromBatchReported();
                        else handleBatchReportedUpdate();
                      }}
                    >
                      {t("mark_as_suspicious_label")}
                    </button>

                    <button
                      className="btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (isBatchApproved) removeFromBatchApproved();
                        else handleBatchApprovedUpdate();
                      }}
                    >
                      {t("mark_as_trusted_label")}
                    </button>
                  </>
                )}

              {((article.status === "active" && article.catalogListing === true) ||
                (article.status === "pause" && article.catalogListing === true)) && (
                  <button className="btn catalogo" onClick={openArticleModalCatalogo}>
                    {t("mark_as_catalogo_label")}
                  </button>
                )}
            </div>
          </div>

          {hasPicture && images && images.length >= 1 && (
            <Carousel
              wrap={false}
              interval={0}
              indicators={false}
              onSelect={(index, e) => e.stopPropagation()}
              nextIcon={<div aria-hidden="true" className="thumbnail-images-arrow icon-chevron right" />}
              prevIcon={<div aria-hidden="true" className="thumbnail-images-arrow icon-chevron left" />}
            >
              {imagesThumb}
            </Carousel>
          )}

          {!hasPicture && (
            <div className="article-without-picture">
              <div>
                <Icon icon={faCamera} size="3x" />
              </div>
              <div>{t("article_without_picture")}</div>
            </div>
          )}
        </div>

        <span className="article-separator-bar"></span>

        {article.catalogListing && !article.tags?.includes("content_editable") && (
          <div className="label_catalogo tienda">{t("catalogue")}</div>
        )}

        {article.tags?.includes("content_editable") && article.catalogListing && (
          <div className="label_similar tienda">{t("similar")}</div>
        )}

        {article.officialStoreId && !article.catalogListing && (
          <div className="label_catalogo tienda tienda_green">{t("official_store")}</div>
        )}

        <div className="article-detail">
          <ArticlePrice article={article} className="article-price" />
          {isInternationalPurchase && (
            <div className="labelInternational">
              {t("international_purchase").toUpperCase()} {CBTCountry}
            </div>
          )}

          <div className="article-title">
            <div title={titleTranslate} className="main-title">
              {titleTranslate.length > 54
                ? titleTranslate.substr(0, 45) + "..."
                : titleTranslate}
            </div>

            {article?.seller && (
              <div className="article-seller" title={article.seller.name}>
                {article.seller.name}
              </div>
            )}

            {article.country && (
              <div className="article-country">
                <div className="country-flag">
                  <img
                    className="flags ls-modal-flags"
                    alt={`flag-${article.country.code}`}
                    src={`/images/countries/${article.country.code}.png`}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div >
  );
};

const mapStateToProps = (state) => ({
  lang: state.global.lang,
  liveSearch: state.detail.liveSearch,
  batchApproved: state.detail.batchApproved,
  batchReported: state.detail.batchReported,
  isUpdatingArticle: state.detail.isUpdatingArticle,
});

const actions = {
  approveArticle,
  reportArticleUndo,
  setArticlesPinned,
  approveArticleUndo,
  batchApprovedUpdate,
  batchReportedUpdate,
  closeModal,
};

export default connect(mapStateToProps, actions)(withRouter(ArticleCard));
